<script setup lang="ts">
import { ref, computed } from 'vue'
const emits = defineEmits(['update:modelValue'])

const props = defineProps<{
  copyText: string
  modelValue: boolean
}>()

const isShowTooltip = ref(false);
const prevTimeoutId = ref<ReturnType<typeof setTimeout>>(0 as any);

const buttonName = computed(() => {
  return isShowTooltip.value ? 'コピーしました' : '内容をコピー'
})

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text)
  showTooltip()
}

const showTooltip = () => {
  isShowTooltip.value = true
  emits('update:modelValue', true)
  clearTimeout(prevTimeoutId.value)
  prevTimeoutId.value = setTimeout(() => {
    isShowTooltip.value = false
  }, 2000)
}
</script>
<template>
  <v-btn
    color="#1976D2"
    style="color: white"
    @click="copyToClipboard(props.copyText)"
  >
  {{ buttonName }}
  </v-btn>
</template>